export const nameOf = <T>(name: keyof T) => name;
